import type { ReactNode } from "react";
import { FileText, Settings2, Workflow } from "lucide-react";
import { StepInfoRow } from "../StepInfoRow";
import { getString, getBool } from "./helpers";
import type { SummaryTranslator } from "./types";

export function getSubworkflowSummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const workflowId = getString(config.workflowId);
  const waitForCompletion = getBool(config.waitForCompletion);
  const inputMap = config.inputMap as Record<string, unknown> | undefined;

  if (workflowId) {
    items.push(
      <StepInfoRow key="wfId" icon={<Workflow className="size-3.5" />} label={t("summaries.subworkflow.label_workflow")} value={t("summaries.subworkflow.workflow_linked")} mono />
    );
  }

  if (waitForCompletion) {
    items.push(
      <StepInfoRow
        key="wait"
        icon={<Settings2 className="size-3.5" />}
        label={t("summaries.subworkflow.label_wait")}
        value={
          <span className="rounded bg-pink-100 px-1.5 py-0.5 text-[10px] font-medium text-pink-700 dark:bg-pink-900/30 dark:text-pink-300">
            {t("summaries.subworkflow.wait_for_completion")}
          </span>
        }
      />
    );
  }

  if (inputMap) {
    const count = Object.keys(inputMap).length;
    if (count > 0) {
      items.push(
        <StepInfoRow key="inputMap" icon={<FileText className="size-3.5" />} label={t("summaries.subworkflow.label_input_map")} value={t("summaries.subworkflow.input_fields_count", { count })} />
      );
    }
  }

  return items;
}
